// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__3DmLY","menu_button":"navbar_menu_button__r5ity","menu_icon":"navbar_menu_icon__1fWtH","logo":"navbar_logo__1jgnN"};